
export const mapPeriod = (compareType) =>{

    if (compareType === "previousPeriod"){
        return "Kỳ trước"
    }else if (compareType === "periodLastYear") {
        return "Cùng kỳ năm ngoái"
    }else{
        return ""
    }
}
